export default "__VITE_ASSET__BfJU0rBQ__"